export default __webpack_public_path__ + "static/media/startDemo2.214e50e7.mp3";